// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartFulfillmentMethodStyles } from "@eisinc/Overrides/Widgets/Cart/CartFulfillmentMethodSelector";
import Directions from "@eisinc/XDL/Icons/Directions";
import Edit from "@eisinc/XDL/Icons/Edit";
import PickUpInstruction from "@eisinc/XDL/Icons/PickUpInstruction";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color, createLinkIconStyles } from "@eisinc/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

cartFulfillmentMethodStyles.fulfillmentMethodWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        padding-top: 12px;
        margin: 0 12px;
        border-top: 1px solid ${color("common.border")};
        gap: 12px;
    `,
};

cartFulfillmentMethodStyles.fulfillmentMethodradioGroup = {
    labelProps: {
        css: css`
            &&& {
                margin-bottom: 8px;
            }
        `,
    },
};

cartFulfillmentMethodStyles.pickUpLocation = {
    pickupAddressWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 8px;
        `,
    },
    changeLink: {
        ...createLinkIconStyles({ icon: Edit, sizeVariant: "small" }),
    },
    directionsLink: {
        ...createLinkIconStyles({ icon: Directions, sizeVariant: "small" }),
    },
    instructionsLink: {
        ...createLinkIconStyles({ icon: PickUpInstruction, sizeVariant: "small" }),
    },
    warehouseAddress: {
        address: {
            wrapper: {
                css: css`
                    ${TypographyStyle} {
                        font-size: ${fontConfig.xSmall.size}px;
                        line-height: ${fontConfig.xSmall.lineHeight};
                    }
                `,
            },
        },
        nameText: {
            variant: "h6",
            as: "p",
        },
    },
};
